import React, { FC } from "react";
import { Avatar, AvatarProps, Tooltip, TooltipProps } from "antd";
import { Organization } from "../../graphql/types";
import { colorFromUuid } from "../../util/colorFromUuid";
import { UsergroupAddOutlined } from "@ant-design/icons";

interface Props extends AvatarProps {
  organization: Pick<Organization, "id" | "imageUrl" | "name">;
  tooltip?: Partial<TooltipProps>;
}

export const OrganizationAvatar: FC<Props> = ({
  organization,
  tooltip,
  className = "",
  ...otherProps
}) => (
  <Tooltip title={organization.name} placement="top" {...tooltip}>
    <Avatar
      src={organization.imageUrl}
      icon={organization.name?.[0]?.toUpperCase() ?? <UsergroupAddOutlined />}
      {...otherProps}
      style={{
        backgroundColor: !organization.imageUrl
          ? colorFromUuid(organization.id)
          : undefined,
        ...otherProps.style,
      }}
      className={`bg-component ${className}`}
    />
  </Tooltip>
);
